export default __webpack_public_path__ + "static/hero-47f082d521410fa662348e9b88f698b8.png";